import React, { useEffect, useState, forwardRef } from 'react';
import styles from './ExpandableContainer.module.scss';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';

const ExpandableContainer = forwardRef(function ExpandableContainer(
  {
    children,
    title,
    onDelete,
    innerClassName,
    headerClassName,
    accordionClassName,
    index,
    isExpanded,
  },
  ref
) {
  const [isOpen, setIsOpen] = useState(isExpanded ?? false);

  useEffect(() => {
    if (typeof isExpanded === 'boolean') {
      setIsOpen(isExpanded ?? false);
    }
  }, [isExpanded]);

  const handleExpandCollapse = () => {
    setIsOpen((prev) => !prev);
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    if (onDelete) {
      typeof index === 'number' ? onDelete(index) : onDelete();
    }
  };

  return (
    <div
      ref={ref}
      className={`${styles.accordion} ${accordionClassName ?? ''}`}
    >
      <div
        onClick={handleExpandCollapse}
        className={`${styles.header} ${headerClassName ?? ''}`}
      >
        <div className={styles.title}>{title}</div>
        <div className={styles.image}>
          <SvgWithBranding
            type='delete_table'
            className={styles.deleteIcon}
            onClick={handleDelete}
          />
          <SvgWithBranding
            type='arrow'
            className={`${styles.icon} ${isOpen ? styles.up : styles.down}`}
          />
        </div>
      </div>

      <div
        className={`${styles.content} ${
          isOpen ? styles.expanded : styles.collapsed
        }`}
      >
        <div className={`${styles.contentInner} ${innerClassName ?? ''}`}>
          {children}
        </div>
      </div>
    </div>
  );
});

export default ExpandableContainer;
